import {
  FaFolder,
  FaFile,
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFilePowerpoint,
  FaFileImage,
  FaFileArchive,
  FaFileCode,
  FaFileAlt,
  FaFileVideo,
  FaFileAudio,
} from 'react-icons/fa';

const KIND_RULES = [
  { kind: 'image',    test: (ct, ext) => ct.includes('image')      || ['jpg','jpeg','png','gif','webp','svg','bmp','heic','heif'].includes(ext), icon: FaFileImage,      color: '#0ea5e9' },
  { kind: 'pdf',      test: (ct, ext) => ct.includes('pdf')        || ext === 'pdf',                                                            icon: FaFilePdf,        color: '#dc2626' },
  { kind: 'word',     test: (ct, ext) => ct.includes('word')       || ct.includes('wordprocessingml') || ct.includes('msword') || ['doc','docx','rtf'].includes(ext),                  icon: FaFileWord,       color: '#2563eb' },
  { kind: 'excel',    test: (ct, ext) => ct.includes('excel')      || ct.includes('spreadsheetml')    || ct.includes('ms-excel') || ['xls','xlsx','csv'].includes(ext),                icon: FaFileExcel,      color: '#16a34a' },
  { kind: 'ppt',      test: (ct, ext) => ct.includes('powerpoint') || ct.includes('presentationml')   || ct.includes('ms-powerpoint') || ['ppt','pptx'].includes(ext),                 icon: FaFilePowerpoint, color: '#ea580c' },
  { kind: 'video',    test: (ct, ext) => ct.startsWith('video/')   || ['mp4','mov','avi','webm','mkv'].includes(ext),                          icon: FaFileVideo,      color: '#7c3aed' },
  { kind: 'audio',    test: (ct, ext) => ct.startsWith('audio/')   || ['mp3','wav','ogg','flac','m4a'].includes(ext),                          icon: FaFileAudio,      color: '#db2777' },
  { kind: 'archive',  test: (ct, ext) => ct.includes('zip')        || ct.includes('compressed') || ct.includes('rar') || ['zip','rar','7z','tar','gz'].includes(ext),                  icon: FaFileArchive,    color: '#f97316' },
  { kind: 'code',     test: (ct, ext) => ct.includes('javascript') || ct.includes('json')             || ['js','jsx','ts','tsx','json','html','css','scss','xml','yml','yaml'].includes(ext), icon: FaFileCode, color: '#6366f1' },
  { kind: 'text',     test: (ct, ext) => ct.includes('text')       || ['txt','log','md'].includes(ext),                                        icon: FaFileAlt,        color: '#64748b' },
];

export const getExtension = (filename = '') => {
  const idx = filename.lastIndexOf('.');
  return idx >= 0 ? filename.slice(idx + 1).toLowerCase() : '';
};

export const getFileMeta = (item) => {
  if (item?.asset_type === 'folder') {
    return { kind: 'folder', icon: FaFolder, color: '#0d6efd' };
  }
  const ct = (item?.content_type || '').toLowerCase();
  const ext = getExtension(item?.name);
  const found = KIND_RULES.find(({ test }) => test(ct, ext));
  return found
    ? { kind: found.kind, icon: found.icon, color: found.color }
    : { kind: 'other', icon: FaFile, color: '#64748b' };
};

export const isPreviewableInline = (kind) => kind === 'image' || kind === 'pdf' || kind === 'video' || kind === 'audio';
